module.exports = __webpack_public_path__ + "img/mat_107.89700923.png";